import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import MovieCard from "@/components/feature/MovieCard";
import EmptyState from "@/components/base/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useFavorites } from "@/hooks/useFavorites";
import { getMediaById } from "@/utils/media";

export default function FavoritesPage() {
  usePageMeta({
    title: "我的收藏 - 17C.COM",
    description: "查看你在 17C.COM 收藏的影视作品。收藏记录保存在浏览器本地，随时回顾想看的内容。",
    keywords: "我的收藏,影视收藏,17C.COM",
  });

  const { favorites, clearFavorites } = useFavorites();
  const items = favorites
    .map((id) => getMediaById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "我的收藏" }]} />

      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            我的收藏
          </h1>
          <p className="mt-2 text-sm text-foreground-500">
            共收藏 <span className="font-bold text-primary-600">{items.length}</span> 部作品
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Link
            to="/history"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-history-line" aria-hidden="true" />
            浏览记录
          </Link>
          {items.length > 0 && (
            <button
              type="button"
              onClick={clearFavorites}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100"
            >
              <i className="ri-delete-bin-line" aria-hidden="true" />
              清空收藏
            </button>
          )}
        </div>
      </div>

      {items.length > 0 ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {items.map((item) => (
            <MovieCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <EmptyState
          icon="ri-heart-3-line"
          title="还没有收藏任何影视作品"
          description="在影视详情页点击「收藏」，喜欢的内容就会出现在这里。"
          action={
            <Link
              to="/category"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-play-list-line" aria-hidden="true" />
              去发现好作品
            </Link>
          }
        />
      )}
    </div>
  );
}